import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "box black border-radius-none" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("code", null, ".border-radius-none", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("code", null, "$border-radius-none", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "box black border-radius-sm" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("code", null, ".border-radius-sm", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("code", null, "$border-radius-sm", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "box black border-radius-md" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("code", null, ".border-radius-md", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("code", null, "$border-radius-md", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "box black border-radius-lg" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("code", null, ".border-radius-lg", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("code", null, "$border-radius-lg", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "box black border-radius-pill" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("code", null, ".border-radius-pill", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("code", null, "$border-radius-pill", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "box black border-radius-circular" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("code", null, ".border-radius-circular", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("code", null, "$border-radius-circular", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "style-guide--border-radius" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "4",
        lg: "3",
        xxl: "2"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "4",
        lg: "3",
        xxl: "2"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "4",
        lg: "3",
        xxl: "2"
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "4",
        lg: "3",
        xxl: "2"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _hoisted_11,
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "4",
        lg: "3",
        xxl: "2"
      }, {
        default: _withCtx(() => [
          _hoisted_13,
          _hoisted_14,
          _hoisted_15
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "4",
        lg: "3",
        xxl: "2"
      }, {
        default: _withCtx(() => [
          _hoisted_16,
          _hoisted_17,
          _hoisted_18
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}